import React, { useState } from "react";
import axios from "axios";
import { API_BASE } from "../config/api";
import "./ContactPage.css";

const ContactPage = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await axios.post(`${API_BASE}/contact/submit`, form);
      
      if (response.data.success) {
        setSubmitted(true);
        setForm({ name: "", email: "", message: "" });
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to send message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-container">
      <h1>We're Here to Help</h1>
      <div className="contact-main-content">
        <div className="contact-left-section">
          <section className="contact-info-section">
            <h2>Get in Touch</h2>
            <p>
              We'd love to hear from you! Whether you have a question about our jewelry, want to discuss a custom piece, or need support, our team is here to help.
            </p>
            <div className="contact-details">
              <div><b>Email:</b> <a href="mailto:support.panchalijewels@gmail.com">support.panchalijewels@gmail.com</a></div>
              <div><b>Phone:</b> <a href="tel:+919696581515">+91 96965 81515</a></div>
              <div><b>Address:</b> 123, <span className="brand-name-gold">Panchali Jewels</span> Lane, Mumbai, India</div>
            </div>
          </section>
          <section className="contact-business-section">
            <h2>Business Inquiries</h2>
            <p>
              For wholesale, partnership, or press inquiries, please email us at <a href="mailto:business@panchalijewels.com">business@panchalijewels.com</a>.
            </p>
          </section>
        </div>
        <div className="contact-right-section">
          <section className="contact-form-section">
            <h2>Send Us a Message</h2>
            {submitted ? (
              <div className="contact-success">Thank you for reaching out! We'll get back to you soon.</div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                {error && <div className="contact-error">{error}</div>}
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    required
                    autoComplete="off"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    required
                    autoComplete="off"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    required
                    rows={5}
                  />
                </div>
                <button type="submit" className="contact-submit-btn" disabled={loading}>
                  {loading ? "Sending..." : "Send Message"}
                </button>
              </form>
            )}
          </section>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;